import React from 'react';

import { Header, FleetList as FleetListComponent } from 'components';
import { PrivateRoute } from 'utils';

export const FleetListPage = () => {
  PrivateRoute();

  return (
    <>
      <Header />
      <FleetListComponent />
    </>
  );
};
